module.exports = __webpack_public_path__ + "static/media/fwd-dark.4160e88f.svg";